import {defineStore} from 'pinia'
import {isEmpty} from "lodash";
import Vue from "vue";

export const useUsersStore = defineStore('users', {
    state: () => {
        return {
            users: [],
            usersInitialState: [],
            // TODO: This is not reactive yet.
            consolidatedUsersAndSubUsers: [],
        }
    },
    actions: {
        setUsers(users) {
            Vue.set(this, 'users', users);
        },
        getUsers() {
            return this.users;
        },
        getUsersInitialState() {
            if (typeof this.usersInitialState !== 'undefined' && ! isEmpty(this.usersInitialState)) {
                return JSON.parse(this.usersInitialState);
            }
        },
        setUsersInitialState(users) {
            this.usersInitialState = JSON.stringify(users);
        }
    },
    getters: {}

})
